import { Collapse } from 'antd'
import { getAngledImage } from '@OpsQuality/logic'
import { ALLOWED_ATTACHMENT_SOURCE_TYPE } from '@OpsQuality/constants'
import { SingularProcessesType } from '@OpsQuality/components/Inspection/components/types'

import Image from '~/core/Image'
import Box from '~/core/Box'

import UploadUI from './UploadUI'
import styles from './styles.css'

const { Panel } = Collapse

export default function SingularProcess(props: SingularProcessesType) {
    const {
        jobRequestId,
        attachmentTypeDetails,
        attachmentSource,
        isJobCompleted,
    } = props

    const { attachmentTypeData, jobRequestLinesByProcessTypeOrMaterialType } =
        attachmentTypeDetails

    const activElement = jobRequestLinesByProcessTypeOrMaterialType[0]?.id || 1

    return (
        <Box direction="col" height="100%" maxWidth="400px">
            {attachmentSource === ALLOWED_ATTACHMENT_SOURCE_TYPE.QC && (
                <Box direction="col">
                    <span style={{ margin: '20px 20px 0 20px' }}>
                        Please attach the required documents for the following
                        part.
                    </span>
                </Box>
            )}
            <Collapse
                defaultActiveKey={[activElement]}
                expandIconPosition={'right'}
                bordered={false}
            >
                {jobRequestLinesByProcessTypeOrMaterialType?.map(
                    jobRequestLine => {
                        const thumbnail = getAngledImage(jobRequestLine) || ''

                        return (
                            <Panel
                                header={
                                    <>
                                        <Image
                                            width="33px"
                                            height="33px"
                                            alt=""
                                            src={thumbnail}
                                            className={
                                                styles.thumbnailImageBorder
                                            }
                                        />
                                        {jobRequestLine.name}
                                    </>
                                }
                                key={jobRequestLine.id}
                            >
                                <Box style={{ flexWrap: 'wrap' }}>
                                    <UploadUI
                                        selectedJobRequestLines={[
                                            jobRequestLine,
                                        ]}
                                        jobRequestId={jobRequestId}
                                        attachmentTypeDetails={{
                                            attachmentTypeData:
                                                attachmentTypeData,
                                            jobRequestLinesByProcessTypeOrMaterialType:
                                                [jobRequestLine],
                                        }}
                                        multiple
                                        attachmentSource={attachmentSource}
                                        uploadTitle={`Upload photos(s)`}
                                        isJobCompleted={isJobCompleted}
                                    />
                                </Box>
                            </Panel>
                        )
                    },
                )}
            </Collapse>
        </Box>
    )
}
